import React from 'react';
import cameraPicture from '../media/camera-picture.svg';
import styles from '../styles.module.css';

type InfoCardProps = {
  title?: string;
  description?: string;
};

export const InfoCard = ({ title, description }: InfoCardProps) => {
  if (!title && !description) return null;

  return (
    <div className={styles.infoCardSection}>
      <div className={styles.infoCardIcon}>
        <img src={cameraPicture} alt="camera-picture" />
      </div>
      <div className={styles.infoCardTexts}>
        {title && <span className={styles.infoCardTitle}>{title}</span>}
        {description && (
          <span className={styles.infoCardDescription}>{description}</span>
        )}
      </div>
    </div>
  );
};
